import React from "react";
import { Box, Flex, keyframes } from "@chakra-ui/react";

const circleAnimation = keyframes`
0%{
  opacity:1;
  transform: scale(1);
}
53%{
  opacity:1;
}
100%{
  opacity:0;
  transform: scale(3.6);
}
`;

const CircleAnimation = ({ ...rest }) => {
  return (
    <Flex {...rest} justifyContent="center" alignItems="center">
      <Box
        bg="primaryLight"
        animation={`${circleAnimation} 4.3s ease-in-out infinite`}
        minWidth="56px"
        height="56px"
        borderRadius="100%"
      />
    </Flex>
  );
};

export default React.memo(CircleAnimation);
